<template>
  <Dialog class="mobile dragon-dead-dialog" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common" :showClose="true">
    <div class="box">
       <div class="text text1">{{ $t('mwr.dragon.superBox.text1') }}</div>
       <div class="text text2">{{ $t('mwr.dragon.superBox.text2') }}</div>
       <div class="text text3">{{ $t('mwr.dragon.superBox.text3') }}</div>
       <div class="props-wrap">
        <div class="prop prop-1">
          <img src="~@/assets/imgs/act/mwr/dragon/prop-1.png" alt="">
        </div>
        <div class="prop prop-2">
          <img src="~@/assets/imgs/act/mwr/dragon/prop-2.png" alt="">
        </div>
        <div class="prop prop-3">
          <img src="~@/assets/imgs/act/mwr/dragon/prop-3.png" alt="">
        </div>
       </div>
    </div>
  </Dialog>
</template>

<script setup>
/* eslint-disable */
import Dialog from '@/components/Dialog/ActMwr/index.vue'
import { defineProps, defineEmits, computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const updateModelValue = (value) => {
  emit('update:modelValue', value)
}
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
